import React from "react";
import PropTypes from "prop-types";

// Material
import { Box, makeStyles, TextField, Typography, withStyles } from "@material-ui/core";

// components
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
    searchInputLabel: {
        color: theme.palette.common.white,
        fontSize: "14px",
        marginBottom: "4px",
    },
}));

const StyledTextField = withStyles((theme) => ({
    root: {
        background: theme.palette.common.white,
        borderRadius: "10px",
        overflow: "hidden",
        "& .MuiInputBase-input": {
            padding: "7px 14px!important",
            fontWeight: 500,
            fontSize: "inherit",
            "&:-webkit-autofill": {
                WebkitBoxShadow: `0 0 0 100px ${theme.palette.common.white} inset`,
            },
        },

        "& .Mui-disabled": {
            pointerEvents: "none",
            opacity: 0.5,
        },
        "& .MuiInputAdornment-root": {
            fontSize: "inherit",
        },

        "& .MuiFormHelperText-root": {
            marginTop: theme.spacing(1.5),
        },

        "& .MuiInputBase-root": {
            minHeight: "40px",
            fontSize: "16px",
            borderRadius: "3px",
            paddingRight: "70px",
            "& fieldset": {
                borderColor: "#6D6D6D",
            },
            "&:hover fieldset": {
                borderColor: "#6D6D6D",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#6D6D6D",
            },
        },

        "& .MuiAutocomplete-endAdornment": {
            "& .MuiAutocomplete-clearIndicator": {
                visibility: "visible",
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: 1.5,
                textAlign: "center",
                color: "#6886EF",
                paddingRight: "10px",
            },
            "& .MuiAutocomplete-clearIndicator:hover": {
                backgroundColor: "unset",
            },
        },
    },
}))(TextField);

export default function SearchField({ label, placeholder, closeIconLabel, value, onChange }) {
    const classes = useStyles();

    const handleMaxTags = (e) => {
        if (value.length >= 5) {
            e.preventDefault();
        }
    };

    return (
        <Box>
            <Typography className={classes.searchInputLabel}>{label}</Typography>
            <Autocomplete
                closeIcon={<span>{closeIconLabel}</span>}
                multiple
                options={[]}
                freeSolo
                autoSelect
                onChange={onChange}
                value={value}
                disableClearable={value.length === 0}
                onKeyPress={handleMaxTags}
                renderInput={(params) => (
                    <StyledTextField
                        {...params}
                        placeholder={value.length === 0 ? placeholder : ""}
                        InputProps={{ ...params.InputProps, disableUnderline: true }}
                        inputProps={{
                            ...params.inputProps,
                            maxLength: 5,
                            onPaste: handleMaxTags,
                        }}
                    />
                )}
            />
        </Box>
    );
}

SearchField.propTypes = {
    value: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    closeIconLabel: PropTypes.string.isRequired,
    onChange: PropTypes.func,
};
